import { useEffect } from "react";

const DynamicManifestLink: React.FC = () => {
  useEffect(() => {
    const existing = document.querySelector('link[rel="manifest"]');
    if (existing) {
      existing.remove();
    }

    const link = document.createElement("link");
    link.rel = "manifest";
    const subDomain = window.location.host.split(".")[0];
    if (subDomain === "lakesidetitle") {
      link.href = "/site-lakeside.webmanifest";
    } else {
      link.href = "/site.webmanifest";
    }

    document.head.appendChild(link);
  }, []);

  return null;
};

export default DynamicManifestLink;
